import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, Suspense } from "react";
import axios from "axios";
import userStore from "../../../../zustand/userStore";
import { apiKeyHeader } from "../../../../configs/ApiKeys";
import { WSLogDocumentClick } from "../../../../configs/WebService";
import { getDocumentsData } from "../redux/eventOrganiserThunks";
import { FileText, ArrowRight, ArrowLeft } from "lucide-react";
import { Header } from "../../../Header";
import Footer from "../../../Footer";
import { docCardTitle } from "../../../../OtherFunctions/docCardTitle";
import "./ViewAllDocuments.css";

const ViewAllDocuments = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { documentList = [] } = useSelector((store) => store.eventOrganiser);

  useEffect(() => {
    if (documentList.length === 0) {
      dispatch(getDocumentsData({ type: "propertyDoc" }));
    }
  }, [dispatch, documentList.length]);

  const category = documentList.find(
    (cat) => String(cat.categoryId) === String(categoryId)
  );

  const handleDocumentClick = async (doc) => {
    const userId = userStore.getState().user?.id;

    if (userId && Number(userId) > 0) {
      try {
        await axios.post(
          `${WSLogDocumentClick}?userId=${encodeURIComponent(userId)}`,
          {
            title: doc?.name_title || docCardTitle(doc),
            docFormId: doc?.id,
          },
          {
            headers: apiKeyHeader(),
          }
        );
      } catch (error) {
        console.error("Failed to log document click:", error);
      }
    }

    navigate("/docFormTestRunNew?formId=" + doc.id, {
      state: {
        nameTitle: doc?.name_title,
        languageId: doc.languageId,
      },
    });
  };

  return (
    <Suspense fallback={<>Loading...</>}>
      <div className="view-all-page">
        <Header />

        <main className="view-all-main">
          {/* Breadcrumb / back */}
          <div className="view-all-breadcrumb">
            <button
              className="view-all-back-btn"
              onClick={() => navigate("/home")}
            >
              <ArrowLeft />
              Back to Home
            </button>
          </div>

          {/* Page heading */}
          <div className="view-all-heading">
            <h1 className="view-all-title">
              {category ? category.categoryName : "All Documents"}
            </h1>
            {category && (
              <span className="view-all-count">
                {category.forms?.length || 0} documents
              </span>
            )}
          </div>

          {/* Grid */}
          {!category ? (
            <p className="view-all-empty">Category not found.</p>
          ) : category.forms && category.forms.length > 0 ? (
            <div className="view-all-grid">
              {category.forms.map((doc) => (
                <div
                  key={doc.id}
                  className="view-all-card"
                  onClick={() => handleDocumentClick(doc)}
                >
                  <div className="view-all-card-inner">
                    <div className="view-all-card-icon">
                      <FileText />
                    </div>
                    <span className="view-all-card-title">
                      {docCardTitle(doc)}
                    </span>
                  </div>
                  <div className="view-all-card-arrow">
                    <ArrowRight />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="view-all-empty">No documents available.</p>
          )}
        </main>

        <Footer />
      </div>
    </Suspense>
  );
};

export default ViewAllDocuments;
